import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { fetchContent, adminUpdateContent } from "@/lib/api";

const inputCls = "w-full border border-border px-3 py-2 font-mono text-sm focus:outline-none focus:ring-1 focus:ring-foreground";

const ShippingAdmin = () => {
  const [rows, setRows] = useState(null);
  const [freeRO, setFreeRO] = useState({ enabled: false, threshold: 399 });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchContent().then((c) => {
      setRows(c.shipping_countries || []);
      if (c.free_shipping_ro) setFreeRO({ enabled: !!c.free_shipping_ro.enabled, threshold: c.free_shipping_ro.threshold ?? 399 });
    });
  }, []);

  if (!rows) return <div className="p-8 font-mono text-xs uppercase tracking-widest text-muted-foreground">…</div>;

  const setRow = (i, k, v) => setRows((r) => { const a = [...r]; a[i] = { ...a[i], [k]: v }; return a; });
  const addRow = () => setRows((r) => [...r, { name_ro: "", name_en: "", price: 0 }]);
  const delRow = (i) => setRows((r) => r.filter((_, j) => j !== i));

  const save = async () => {
    setSaving(true);
    try {
      const clean = rows
        .filter((r) => (r.name_ro || "").trim() || (r.name_en || "").trim())
        .map((r) => ({ name_ro: (r.name_ro || "").trim(), name_en: (r.name_en || "").trim(), price: parseInt(r.price, 10) || 0 }));
      await adminUpdateContent({
        shipping_countries: clean,
        free_shipping_ro: { enabled: !!freeRO.enabled, threshold: parseInt(freeRO.threshold, 10) || 0 },
      });
      setRows(clean);
      toast.success("Livrare salvată");
    } catch { toast.error("Eroare la salvare"); }
    setSaving(false);
  };

  return (
    <div className="p-5 sm:p-8" data-testid="shipping-admin">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-xl uc font-semibold">Livrare</h2>
        <button data-testid="shipping-save" onClick={save} disabled={saving} className="bg-foreground px-6 py-3 font-mono text-[11px] uppercase tracking-widest text-white hover:opacity-85 disabled:opacity-50">{saving ? "..." : "Salvează"}</button>
      </div>

      <div className="mb-8 border border-border p-4" data-testid="free-shipping-ro">
        <label className="flex items-center gap-2">
          <input type="checkbox" data-testid="free-shipping-toggle" checked={freeRO.enabled} onChange={(e) => setFreeRO((f) => ({ ...f, enabled: e.target.checked }))} />
          <span className="font-mono text-[11px] uppercase tracking-widest">Livrare gratuită în România pentru comenzi peste</span>
          <input type="number" data-testid="free-shipping-threshold" className={inputCls + " max-w-[120px]"} value={freeRO.threshold} onChange={(e) => setFreeRO((f) => ({ ...f, threshold: e.target.value }))} />
          <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">RON</span>
        </label>
        <p className="mt-2 font-mono text-[10px] uppercase leading-relaxed tracking-widest text-muted-foreground">
          Când e bifat, comenzile din România cu subtotal peste prag au livrare 0 lei (se aplică automat la checkout).
        </p>
      </div>

      <p className="mb-6 font-mono text-[10px] uppercase leading-relaxed tracking-widest text-muted-foreground">
        Adaugă țările și prețul de livrare (RON). Clientul din străinătate alege țara la checkout și vede costul.
      </p>

      <div className="overflow-x-auto border border-border">
        <table className="w-full border-collapse" data-testid="shipping-table">
          <thead>
            <tr className="border-b border-border bg-secondary font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="px-3 py-2 text-left">Țară (RO)</th>
              <th className="px-3 py-2 text-left">Country (EN)</th>
              <th className="px-3 py-2 text-left">Preț livrare (RON)</th>
              <th className="px-3 py-2" />
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={4} className="px-3 py-6 text-center font-mono text-[11px] uppercase tracking-widest text-muted-foreground">Nicio țară adăugată</td></tr>
            ) : rows.map((r, i) => (
              <tr key={i} className="border-b border-border" data-testid={`shipping-row-${i}`}>
                <td className="px-3 py-2"><input className={inputCls} value={r.name_ro || ""} onChange={(e) => setRow(i, "name_ro", e.target.value)} placeholder="ex: Germania" data-testid={`shipping-name-ro-${i}`} /></td>
                <td className="px-3 py-2"><input className={inputCls} value={r.name_en || ""} onChange={(e) => setRow(i, "name_en", e.target.value)} placeholder="ex: Germany" data-testid={`shipping-name-en-${i}`} /></td>
                <td className="px-3 py-2"><input type="number" className={inputCls + " max-w-[160px]"} value={r.price} onChange={(e) => setRow(i, "price", e.target.value)} data-testid={`shipping-price-${i}`} /></td>
                <td className="px-3 py-2 text-right"><button onClick={() => delRow(i)} data-testid={`shipping-remove-${i}`} className="font-mono text-xs text-destructive">×</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button onClick={addRow} data-testid="shipping-add" className="mt-4 border border-border px-5 py-3 font-mono text-[11px] uppercase tracking-widest hover:border-foreground">+ Adaugă țară</button>
    </div>
  );
};

export default ShippingAdmin;
